package co.maytes.standupbot.dashboard.features.standups

object ReviewSettings {
    val leadOptions: List<Int> = listOf(15, 30, 60)
    const val DEFAULT_LEAD_MINUTES = 30
    const val NEEDS_A_DAY = "Pick at least one day to fire on before turning on review."

    private const val MINUTES_PER_HOUR = 60
    private const val MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR
    private const val NOON_HOUR = 12

    fun canReview(spec: ScheduleSpec): Boolean = spec.firesAtLeastOnce

    fun postsAt(spec: ScheduleSpec): String = clock(spec.hour * MINUTES_PER_HOUR + spec.minute)

    fun draftsAt(
        spec: ScheduleSpec,
        leadMinutes: Int,
    ): String = clock((spec.hour * MINUTES_PER_HOUR + spec.minute - leadMinutes).mod(MINUTES_PER_DAY))

    fun leadLabel(minutes: Int): String = "$minutes min"

    fun explanation(
        spec: ScheduleSpec,
        leadMinutes: Int,
    ): String =
        "Each person with activity gets a private draft $leadMinutes minutes before, at ${draftsAt(spec, leadMinutes)}. " +
            "Nobody has to respond; the standup posts at ${postsAt(spec)} either way."

    private fun clock(minuteOfDay: Int): String {
        val hour = minuteOfDay / MINUTES_PER_HOUR
        val minute = minuteOfDay % MINUTES_PER_HOUR
        val hour12 = (hour % NOON_HOUR).let { if (it == 0) NOON_HOUR else it }
        val period = if (hour < NOON_HOUR) "AM" else "PM"
        return "$hour12:${minute.toString().padStart(2, '0')} $period"
    }
}
